import React from 'react';
import { cn } from '@ais-ui/utils';

interface MenuItemProps {
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

/** Shared context menu item used across all context menu item renderers. */
export const MenuItem = ({ disabled, onClick, children }: MenuItemProps) => (
  <div
    role="menuitem"
    tabIndex={disabled ? -1 : 0}
    className={cn(
      'relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none',
      disabled
        ? 'pointer-events-none opacity-50'
        : 'hover:bg-accent hover:text-accent-foreground cursor-pointer',
    )}
    onClick={disabled ? undefined : onClick}
    onKeyDown={(e) => {
      if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
        onClick();
      }
    }}
  >
    {children}
  </div>
);
